import type { ReactNode } from 'react';
import clsx from 'clsx';

type CardProps = {
  title?: ReactNode;
  className?: string;
  children: ReactNode;
  actions?: ReactNode;
  onClick?: () => void;
};

export function Card({ title, className, children, actions, onClick }: CardProps) {
  return (
    <div
      className={clsx('rounded-xl border border-slate-200 bg-white p-4 sm:p-6 shadow-sm', className)}
      onClick={onClick}
    >
      {(title || actions) && (
        <header className="mb-4 flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
          {title && <h3 className="text-lg font-semibold text-slate-800">{title}</h3>}
          {actions && <div className="flex flex-wrap items-center gap-2">{actions}</div>}
        </header>
      )}
      {children}
    </div>
  );
}
